module.exports = __webpack_public_path__ + "img/office_bg.9b512363.jpg";